import { axios } from "../../../lib/axios";

export const createOrganization = (data, parentOrg, deviceUnit, orgLogoURL, operationTiming, sft, appointmentAutoAcceptance, triageSettings) => {
    let newData = {
        "resourceType": "Organization",
        "text": {
            "status": "generated"
        },
        "name": data.name,
        "alias": [
            "HL7 International"
        ],
        "telecom": [
            {
                "system": "phone",
                "value": data.phone_number
            },
            {
                "system": "email",
                "value": data.email?.toLowerCase()
            }
        ],
        "address": [
            {
                "line": [data.address],
                "state": data.state,
                "postalCode": data.postalCode.toUpperCase(),
                "country": data.country,
                "city": data.city,
            }
        ],
        timeZone: data?.timeZone,
        "partOf": parentOrg ? {
            "reference": `Organization/${parentOrg?.id}`,
            "type": "Organization",
            "display": parentOrg?.name,
        } : null,
        "isWaitingRoom": data.isWaitingRoom,
        appointmentCancellationTime: `${data?.appointment_cancel_time || 1}`, // default to 1 minute
        description: data?.description,
        deviceUnit,
        orgLogoURL,
        hoursOfOperation: data.isWaitingRoom && data?.hoursOfOperation ? true : false,
        operationTiming,
        sft,
        triageSettings,
        mfaSettings: {
            enabled: true
        },
        surveySetting: {
            satisfactionSurvey: data?.satisfactionSurvey,
            survey: data?.survey
        },
        ctiSettings: {
            enabled: data?.isCtiEnabled || false,
            dni: data?.dni
        },
        appointmentAutoAcceptance
    }
    return axios.post('organization', newData)
};

export const editOrganization = (data, orgName, orgId, deviceUnit, orgLogoURL = undefined, operationTiming, sft, appointmentAutoAcceptance, mfaSettings, triageSettings) => {

    let newData = {
        "id": data.id,
        "active": data.active,
        "resourceType": "Organization",
        "text": {
            "status": "generated"
        },
        "name": data.name,
        "alias": [
            "HL7 International"
        ],
        "telecom": [
            {
                "system": "phone",
                "value": data.phone_number
            },
            {
                "system": "email",
                "value": data.email?.toLowerCase()
            }
        ],
        "address": [
            {
                "line": [data.address],
                "state": data.state,
                "postalCode": data.postalCode.toUpperCase(),
                "country": data.country,
                "city": data.city,
            }
        ],
        timeZone: data?.timeZone,
        "partOf": {
            "reference": `Organization/${orgId}`,
            "type": "Organization",
            "display": orgName,
        },
        "isWaitingRoom": data.isWaitingRoom,
        "appointmentCancellationTime": `${data?.appointment_cancel_time}`,
        description: data?.description,
        deviceUnit,
        orgLogoURL,
        sft,
        mfaSettings,
        ctiSettings: {
            enabled: data?.isCtiEnabled,
            dni: data?.dni
        },
        triageSettings,
        hoursOfOperation: data.isWaitingRoom && data?.hoursOfOperation ? true : false,
        operationTiming,
        surveySetting: {
            satisfactionSurvey: data?.satisfactionSurvey,
            survey: data?.survey
        },
        appointmentAutoAcceptance
    }

    return axios.put(`organization/${data.id}`, newData)
};

export const getOrganization = (id = null, active = null) => {
  const url =
    active == "false"
      ? (id ? `organization/${id}?active=${active}` : `organization?active=${active}`)
      : (id ? `organization/${id}` : "organization");

  const labelOf = (o) => (o?.name || o?.display || o?.orgName || String(o?.id ?? ""));
  const normalize = (s) =>
    (s || "").normalize("NFKD").replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/\s+/g, " ").trim().toLowerCase();

  const sortInPlace = (arr) =>
    arr.sort((a, b) =>
      normalize(labelOf(a)).localeCompare(normalize(labelOf(b)), undefined, { numeric: true })
    );

  return axios.get(url).then((res) => {
    try {
      if (Array.isArray(res?.data)) sortInPlace(res.data);
      else if (Array.isArray(res?.data?.data)) sortInPlace(res.data.data);
    } catch (e) {
      console.log("Sorting failed for getOrganization api", e);
    }
    return res;
  });
};


export const getOrganizationChild = (id = null) => {
    return axios.get(`organization?orgId=${id}&onlyChild=${true}`)
};


// ---------------discover/organization--------------------------------
export const createDiscover = (payload) => {
    return axios.post(`/discover/organization`, payload);
};
export const editDiscover = (orgID, payload) => {
    return axios.put(`discover/organization/${orgID}`, payload);
};

export const getDiscover = async (orgID) => {
    return axios.get(`discover/organization/${orgID}`);
}


// ---------------organization/settings--------------------------------
export const getOrganizationSettings = async (orgId) => {
    return axios.get(`organization/settings?orgId=${orgId}`);
};

export const editOrganizationSettings = (orgId, payload) => {
    return axios.put(`organization/settings?orgId=${orgId}`, { orgId, ...payload });
};

export const addOrganizationSettings = (orgId, payload) => {
    return axios.post(`organization/settings`, { orgId, ...payload });
};
